import type { ComponentPropsWithoutRef, ElementType } from "react";

import { styled } from "simplydo/react/styled";

const StyledRegular = styled.button`
  background: #e0e1e2 none;
  color: rgba(0, 0, 0, 0.6);
  box-shadow: 0 0 0 1px transparent inset;

  &:hover,
  &:focus {
    background-color: #cacbcd;
    color: rgba(0, 0, 0, 0.8);
  }

  &:active {
    background-color: #babbbc;
    color: rgba(0, 0, 0, 0.9);
  }
`;

type Props = ComponentPropsWithoutRef<"button"> & {
  as?: ElementType;
  className?: string;
};

export function RegularButton({ as, className, ...props }: Props) {
  return <StyledRegular as={as} className={className} {...props} />;
}
